export const muiTableHeadCellPropsHelper =

{
  //color: theme.palette.info.dark,
  fontWeight: '600',
  fontSize: '17px',
  minHeight: '500px',

  padding: '.5rem',
  margin: '.5rem',
  alignContent: 'center',
}

export const muiTableBodyCellPropsHelper = {
  fontWeight: '400',
  fontSize: '13px',
  // maxWidth: 25,
  alignContent: 'center',
}


export const taskTypeColor = [{
  name: 'Assembly',
  color: 'orange',
},
{
  name: 'Picking',
  color: 'yellow',
}, 
{
  name: 'Inventory count',
  color: 'green',
},
{
  name: 'Good received',
  color: 'lightgreen',
},
{
    name: 'Warehouse changes',
  color: 'cyan',
}
,
{
    name: 'Assembly Order',
  color: 'pink',
}
,
{
    name: 'Inventory count - Poland',
  color: 'lightblue',
},
{
    name: 'Inventory count - US',
  color: 'lightblue',
}

       
    
]


